import { render, staticRenderFns } from "./batchPromoteDialog.vue?vue&type=template&id=33de7dd6&scoped=true"
import script from "./batchPromoteDialog.vue?vue&type=script&lang=js"
export * from "./batchPromoteDialog.vue?vue&type=script&lang=js"
import style0 from "./batchPromoteDialog.vue?vue&type=style&index=0&id=33de7dd6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33de7dd6",
  null
  
)

export default component.exports